import { useHead } from '@unhead/react'

interface SEOProps {
  title: string
  description: string
}

export default function SEO({ 
  title, 
  description
}: SEOProps) {
  
  useHead({
    title: title,
    meta: [
      {
        name: 'description',
        content: description
      },
      // {
      //   property: 'og:title',
      //   content: title
      // },
      // {
      //   property: 'og:description',
      //   content: description
      // },
    ]
  })

  return null
}